<template>
  <div class="InfoWrap com-mouse-default">
    <div class="goodsDetail">
      <h3 class="InfoName" style="font-size: 25px">
        {{ info.content }}
      </h3>

      <div class="priceArea">
        <div class="priceArea1 com-flex">
          <div class="com-flex" style="display: flex; align-items: center">
            <div class="title">单箱价格</div>
            <div class="price">
              <i>¥</i>
              <em>{{ info.price }}</em>
            </div>
            <!-- <div class="remark" style="margin-left: 20px;">

              <i>月销量:768箱</i>
            </div> -->
          </div>
        </div>
      </div>
      <div class="support">
        <div class="supportArea">
          <div class="title">剩余库存：</div>
          <div class="fixWidth">100箱</div>
        </div>
      </div>
    </div>

    <!-- 属性列表 -->
    <div class="choose">
      <div class="cartWrap">
        <div class="controls com-flex">
          <div style="border-bottom: 1px solid #ededed">
            <div style="margin-bottom: 10px">装箱配比：</div>
            <div>
              <div style="display: flex; flex-wrap: wrap">
                <div
                  style="
                    display: flex;
                    aligin-item: center;
                    margin-right: 100px;
                    margin-bottom: 20px;
                  "
                >
                  <div style="line-height: 40px">黑色：</div>
                  <el-image
                    style="width: 40px; height: 40px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <el-input-number
                    v-model="skuNum"
                    disabled
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
                <div
                  style="
                    display: flex;
                    aligin-item: center;
                    margin-right: 100px;
                    margin-bottom: 20px;
                  "
                >
                  <div style="line-height: 40px">咖啡：</div>
                  <el-image
                    style="width: 40px; height: 40px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <el-input-number
                    v-model="skuNum1"
                    disabled
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
                <div
                  style="
                    display: flex;
                    aligin-item: center;
                    margin-right: 100px;
                    margin-bottom: 20px;
                  "
                >
                  <div style="line-height: 40px">绿色：</div>
                  <el-image
                    style="width: 40px; height: 40px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <el-input-number
                    v-model="skuNum2"
                    disabled
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
                <div
                  style="
                    display: flex;
                    aligin-item: center;
                    margin-right: 100px;
                    margin-bottom: 20px;
                  "
                >
                  <div style="line-height: 40px">米色：</div>
                  <el-image
                    style="width: 40px; height: 40px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <el-input-number
                    v-model="skuNum3"
                    disabled
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
                <div
                  style="
                    display: flex;
                    aligin-item: center;
                    margin-right: 100px;
                    margin-bottom: 20px;
                  "
                >
                  <div style="line-height: 40px">红色：</div>
                  <el-image
                    style="width: 40px; height: 40px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <el-input-number
                    v-model="skuNum4"
                    :min="1"
                    :max="10"
                    label="描述文字"
                    disabled
                  ></el-input-number>
                </div>
                <div
                  style="
                    display: flex;
                    aligin-item: center;
                    margin-right: 100px;
                    margin-bottom: 20px;
                  "
                >
                  <div style="line-height: 40px">棕色：</div>
                  <el-image
                    style="width: 40px; height: 40px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                  <el-input-number
                    v-model="skuNum5"
                    disabled
                    :min="1"
                    :max="10"
                    label="描述文字"
                  ></el-input-number>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; flex-wrap: wrap; margin-top: 20px">
            <div style="margin-bottom: 10px; line-height: 40px">购买箱数：</div>
            <div>
              <div>
                <div style="margin-right: 100px; margin-bottom: 20px">
                  <el-input-number
                    v-model="skuNum10"
                    :min="1"
                    label="描述文字"
                  ></el-input-number>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            width: 100%;
            min-height: 40px;
            background: #f8f8f8;
            margin-bottom: 15px;
            line-height: 40px;
            display: flex;
          "
        >
          <div style="margin-left: 20px; margin-right: 50px">
            {{ skuNum10 * 24 }}件/{{ skuNum10 }}箱
          </div>
          <div>
            总价格：<span style="color: #ff4400">￥{{ skuNum10 * 899 }}</span>
          </div>
          <div style="margin-left: 20px;">
           体积：<span style="color: #ff4400">{{ skuNum10 *5 }}m³</span>
          </div>
        </div>
        <div class="add com-mouse-point">
          <a class="addCart buy" @click="addCarts" style="background: #ff4400;margin-right:20px;color:#ffffff">加入购物车</a>
          <a class="addCart buy" @click="addCarts">前往购物车</a>
        </div>
      </div>
    </div>
    <el-dialog title="购物车详情" :visible.sync="dialogTableVisible" width="1400px" append-to-body>
      <shopCarts ref="shopCarts"></shopCarts>
    </el-dialog>
    <el-dialog title="支付详情" :visible.sync="dialogTableVisibles" width="550px" append-to-body>
      <div style="display: flex">
        <div>
          <div style="margin-left: 31px">支付宝支付：</div>
          <img
            src=" https://www.gqedu.org.cn:6868/manage/61b18e454c15444aa5102c76fab0cfc0.png"
          />
        </div>
        <div>
          <div style="margin-left: 31px">微信支付：</div>
          <img
            src=" https://www.gqedu.org.cn:6868/manage/61b18e454c15444aa5102c76fab0cfc0.png"
          />
        </div>
      </div>
      <div style="display: flex; justify-content: center">
        <el-button type="success" @click="dialogTableVisiblea = true"
          >上传支付凭证</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="上传凭证" :visible.sync="dialogTableVisiblea" width="550px" append-to-body >
      <el-upload action="#" list-type="picture-card" :auto-upload="false">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{ file }">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleDownload(file)"
            >
              <i class="el-icon-download"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import shopCarts from "../shopCarts/index.vue";
import { mapMutations } from "vuex";
export default {
  name: "InfoDetail",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    shopCarts,
  },
  data() {
    return {
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      ],
      dialogTableVisible: false,
      dialogTableVisiblea: false,
      dialogTableVisibles: false,
      skuNum: 2,
      skuNum1: 3,
      skuNum2: 5,
      skuNum3: 7,
      skuNum4: 3,
      skuNum5: 4,
      skuNum10: 1,
      skuDesc: "全场正品 达人推荐 无忧退换",
    };
  },
  methods: {
    ...mapMutations(["addProd"]),
    sub() {
      if (this.skuNum <= 1) {
        this.skuNum = 1;
        return;
      }
      this.skuNum--;
    },
    add() {
      this.skuNum++;
    },
    addCart() {
      this.dialogTableVisible = true;
    },
    addCarts() {
  
      this.$router.push({ path: "/goods/goodsCart", query: { brandName: this.brandName } });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input-number {
  width: 145px !important;
}

.InfoWrap {
  width: 700px;

  .InfoName {
    font-size: 14px;
    line-height: 21px;
    margin-top: 15px;
  }

  .news {
    color: #3c3c3c;
    margin-top: 15px;
  }

  .priceArea {
    // background: #fff2e8;
    // padding: 7px;
    // margin: 13px 0;

    .priceArea1 {
      overflow: hidden;
      line-height: 28px;
      margin-top: 10px;
      justify-content: space-between;

      .title {
        margin-right: 15px;
      }

      .price {
        i,
        em {
          color: #f40;
        }

        i {
          font-size: 16px;
        }

        em {
          font-size: 24px;
          font-weight: 700;
          margin-left: 5px;
        }

        span {
          font-size: 12px;
        }
      }

      .remark {
        em,
        i {
          text-align: center;
          display: block;
          line-height: 13px;
          height: 15px;
        }
      }
    }

    .priceArea2 {
      overflow: hidden;
      line-height: 28px;
      margin-top: 10px;

      .title {
        margin-right: 15px;
        float: left;
      }

      .fixWidth {
        width: 520px;
        float: left;

        .red-bg {
          background: #f40;
          color: #fff;
          padding: 3px;
        }

        .t-gray {
          color: #999;
        }
      }
    }
  }

  .support {
    border-bottom: 1px solid #ededed;
    padding-bottom: 5px;

    .supportArea {
      overflow: hidden;
      line-height: 28px;
      margin-top: 10px;

      .title {
        margin-right: 15px;
        float: left;
      }

      .fixWidth {
        width: 520px;
        float: left;
        color: #999;
      }
    }
  }

  .choose {
    .chooseArea {
      overflow: hidden;
      line-height: 28px;
      margin-top: 10px;

      dl {
        overflow: hidden;
        margin: 13px 0;

        dt {
          margin-right: 15px;
          float: left;
        }

        dd {
          float: left;
          margin-right: 5px;
          color: #666;
          line-height: 24px;
          padding: 2px 14px;
          border-top: 1px solid #eee;
          border-right: 1px solid #bbb;
          border-bottom: 1px solid #bbb;
          border-left: 1px solid #eee;

          &.active {
            color: green;
            border: 1px solid green;
          }
        }
      }
    }

    .cartWrap {
      .controls {
        position: relative;

        margin: 7px 0;

        .itxt {
          width: 38px;
          height: 34px;
          border: 1px solid #ddd;
          color: #555;
          border-right: 0;
          text-align: center;
          outline: none;
        }

        .plus,
        .mins {
          width: 27px;
          text-align: center;
          height: 38px;
          background: #f1f1f1;
          color: #666;
        }

        span {
          margin-right: 11px;
        }
      }

      .add {
        a {
          width: 180px;
          background-color: #f40;
          padding: 0 25px;
          font-size: 16px;
          color: #fff;
          height: 36px;
          line-height: 36px;
          text-align: center;
          display: inline-block;
          border-radius: 3px;
        }

        .buy {
          width: 134px;
          color: #e5511d;
          border-color: #f0cab6;
          background: #ffe4d0;
          margin-right: 20px;
          padding: 0;
        }
      }
    }
  }
}
</style>
